export default function SentryErrorTest() {
  const badObject = undefined;
  const x = badObject.someProperty;
  console.log(x);
  return null;
}
